import React, {useEffect, useState} from 'react';
import axios from 'axios';
import './NewsUpload.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {
    Button, DialogActions, DialogContent, DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog, Box
} from "@mui/material";
import {FaEye} from "react-icons/fa";
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import CropperModal from "./CropperModal";
import InfoPopup from "../../pages/dashboardapplicationcomponent/InfoPopup";
import InfoIcon from "@mui/icons-material/Info";

const MainPageManager = () => {
    const [title, setTitle] = useState('');
    const [locationPath, setLocationPath] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [description, setDescription] = useState('');
    const [file, setFile] = useState(null);
    const [hasMore, setHasMore] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const [titleEng, setTitleEng] = useState('');
    const [descriptionShortEng, setDescriptionShortEng] = useState('');
    const [descriptionEng, setDescriptionEng] = useState('');
    const [inputKey, setInputKey] = useState(Date.now());
    const [rows, setRows] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [editFile, setEditFile] = useState(null);
    const [editFileName, setEditFileName] = useState('');
    const [editFileURL, setEditFileURL] = useState('');
    const [cropModalOpen, setCropModalOpen] = useState(false);
    const [rawImage, setRawImage] = useState(null);
    const [editCropModalOpen, setEditCropModalOpen] = useState(false);
    const [editRawImage, setEditRawImage] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };


    const [editData, setEditData] = useState({
        id: null,
        title: '',
        descriptionShort: '',
        description: '',
        hasMore: false,
        titleEng: '',
        locationPath: '',
        descriptionShortEng: '',
        descriptionEng: '',
        file: null,
        position: null
    });

    const handleEditOpen = (row) => {
        setIsEditOpen(true);
        setEditData({
            id: row.id,
            title: row.title,
            descriptionShort: row.descriptionShort,
            description: row.description,
            hasMore: row.hasMore,
            titleEng: row.titleEng,
            locationPath: row.locationPath,
            descriptionShortEng: row.descriptionShortEng,
            descriptionEng: row.descriptionEng,
            file: null,
            position: row.position
        });
        setEditFile(null);
        setEditFileName('');
        setEditFileURL('');
    };



    const handleEditFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setEditRawImage(reader.result);
                setEditCropModalOpen(true);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Invalid file format');
        }
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setEditData(prev => ({...prev, [name]: value}));
    };

    const handleEditSubmit = async () => {
        setIsEditOpen(false);
        try {
            const payload = {
                ...editData,
                position: editData.position,
                file: editFile ? {
                    base64String: editFile.split(',')[1],
                    ext: editFile.includes('image/png') ? 'png' : 'jpg'
                } : null
            };
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/EditMainPage`, payload);
            if (response.data.success) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
                await fetchData();
            } else {
                setAlertMessage('Failed to update data');
                setAlertType('error');
            }
        } catch (error) {
            console.error('Edit failed:', error);
            setAlertMessage('Error updating data');
            setAlertType('error');
        }
        setShowAlert(true);
    };

    const handleOpenModal = (id) => {
        setDeleteId(id);
        setIsModalOpenDelete(true);
    };

    const handleCloseModal = () => {
        setIsModalOpenDelete(false);
    };

    const handleDelete = async () => {
        setIsModalOpenDelete(false);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/DeleteMainPage`, {
                id: deleteId
            });
            if (response.data.success) {
                setRows(rows.filter(row => row.id !== deleteId));  // Update UI
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
            } else {
                setAlertMessage('Failed to delete item');
                setAlertType('error');
            }
        } catch (error) {
            console.error('Delete failed:', error);
            setAlertMessage('Error deleting item');
            setAlertType('error');
        }
        setShowAlert(true);
        await fetchData();  // Re-fetch data to update the table
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllMainPage`);
            if (response.data.success && response.data.data) {
                const sorted = [...response.data.data].sort((a, b) => {
                    if (a.position == null) return 1;
                    if (b.position == null) return -1;
                    return a.position - b.position;
                });
                setRows(sorted);
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    const resetForm = () => {
        setTitle('');
        setLocationPath('');
        setShortDescription('');
        setDescription('');
        setFile(null);
        setFileName('');
        setFileURL('');
        setTitleEng('');
        setDescriptionShortEng('');
        setDescriptionEng('');
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setRawImage(reader.result);
                setCropModalOpen(true);
            };
            reader.readAsDataURL(file);
        } else {
            alert('არასწორი ფორმატი');
        }
    };


    const handleDeleteFile = () => {
        setFile(null);
        setFileName('');
        setFileURL('');
        setInputKey(Date.now());
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const handleConfirm = async () => {
        setIsModalOpen(false);

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddMainPage`, {
                title,
                descriptionShort: shortDescription,
                description,
                file: file ? {
                    base64String: file.split(',')[1],
                    ext: file.includes('image/png') ? 'png' : 'jpg'
                } : null,
                hasMore,
                locationPath: locationPath ? locationPath : 'news',
                titleEng,
                descriptionShortEng,
                descriptionEng,
                position: 1,

            });
            resetForm();
            setAlertMessage('სურათი აიტვირთა წარმატებით');
            setAlertType('success');
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertType('error');
        }
        setShowAlert(true);


        const withPosition = rows.map((item, index) => ({
            ...item,
            position: item.position + 1,
            file: null
        }));

        setRows(withPosition);

        for (const item of withPosition) {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/EditMainPage`, item);
        }
        await fetchData();
    };
    const isFormValid = () => {
        return title.trim() !== '' && shortDescription.trim() !== '' && fileName !== '';
    };

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const reordered = [...rows];
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);

        const withPosition = reordered.map((item, index) => ({
            ...item,
            position: index + 1,
            file: null
        }));

        setRows(withPosition);

        for (const item of withPosition) {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/EditMainPage`, item);
        }
    };


    return (
        <div className="news-upload-container">
            <h1 className="page-manager-title">მთავარ გვერდზე სურათის ატვირთვა</h1>
            <form onSubmit={handleSubmit} className="news-upload-form">
                <input
                    key={inputKey}
                    id="file-upload"
                    type="file"
                    name="file"
                    onChange={handleFileChange}
                    accept=".png,.jpg"
                    className="employee-file-input"
                />
                <input type="text" placeholder="სათაური" value={title} onChange={(e) => setTitle(e.target.value)}
                       className="input-field"/>
                <input type="text" placeholder="აღწერა" value={shortDescription}
                       onChange={(e) => setShortDescription(e.target.value)} className="input-field"/>
                <input type="text" placeholder="ღილაკის ტექსტი" value={description}
                       onChange={(e) => setDescription(e.target.value)} className="input-field"/>
                <input type="text" placeholder="სათაური (ინგლსურად)" value={titleEng}
                       onChange={(e) => setTitleEng(e.target.value)} className="input-field"/>
                <input type="text" placeholder="აღწერა (ინგლისურად)" value={descriptionShortEng}
                       onChange={(e) => setDescriptionShortEng(e.target.value)} className="input-field"/>
                <input type="text" placeholder="ღილაკის ტექსტი (ინგლისურად)" value={descriptionEng}
                       onChange={(e) => setDescriptionEng(e.target.value)} className="input-field"/>
                <InfoIcon onClick={() => setDialogOpen(true)} style={{ color: 'red' }} />
                <input type="text" placeholder="ბმული" value={locationPath}
                       onChange={(e) => setLocationPath(e.target.value)} className="input-field"/>
                <InfoPopup hasAddtionalData={true} open={dialogOpen} onClose={handleCloseDialog} title={"გთხოვთ გაითვალისწინოთ:"} info={"თუ სხვა ვებსაიტის მისამართს აკრეფთ ან ჩასვამთ, აუცილებელია მისამართის დასაწყისში მიუთითოთ http:// ან https://, რათა ბრაუზერმა ბმული სწორად ამოიცნოს და მასზე გადასვლა შესაძლებელი იყოს."}/>
                <label htmlFor="file-upload" className="custom-file-upload">
                    {fileName || 'სურათის ატვირთვა (png, jpg)'}
                </label>
                <input id="file-upload" type="file" name="file" onChange={handleFileChange} accept=".png,.jpg"
                       className="employee-file-input"/>

                {fileName && (
                    <div className="file-actions">
                        <a href={fileURL} target="_blank" rel="noopener noreferrer" className="file-preview-link">
                            სურათის ნახვა
                        </a>
                        <button onClick={handleDeleteFile} className="delete-image-button">
                            სურათის წაშლა
                        </button>
                    </div>
                )}
                <button type="submit" className="submit-button-news" disabled={!isFormValid()}>ატვირთვა</button>
            </form>
            <TableContainer style={{marginTop: 20}} component={Paper}>
                <Table sx={{minWidth: 650}} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>სათაური</TableCell>
                            <TableCell align="right">აღწერა</TableCell>
                            <TableCell align="right">სათაური (ინგლსურად)</TableCell>
                            <TableCell align="right">აღწერა (ინგლსურად)</TableCell>
                            <TableCell align="center">სურათის ნახვა</TableCell>
                            <TableCell align="center">ქმედება</TableCell>
                        </TableRow>
                    </TableHead>

                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="mainPageList">
                            {(provided) => (
                                <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                    {rows.map((row, index) => (
                                        <Draggable key={row.id} draggableId={String(row.id)} index={index}>
                                            {(provided) => (
                                                <TableRow
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                                >
                                                    <TableCell>{row.title}</TableCell>
                                                    <TableCell align="right">{row.descriptionShort}</TableCell>
                                                    <TableCell align="right">{row.titleEng}</TableCell>
                                                    <TableCell align="right">{row.descriptionShortEng}</TableCell>
                                                    <TableCell align="center">
                                                        <a href={row.path} target="_blank" rel="noopener noreferrer">
                                                            <FaEye className="uncle-sam-eye"/>
                                                        </a>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box display="flex" justifyContent="center" gap={1}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => handleEditOpen(row)}
                                                                sx={{width: 100}}
                                                            >
                                                                რედაქტირება
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                onClick={() => handleOpenModal(row.id)}
                                                                sx={{width: 100}}
                                                            >
                                                                წაშლა
                                                            </Button>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </TableBody>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Table>

            </TableContainer>
            <Dialog open={isEditOpen} onClose={() => setIsEditOpen(false)} fullWidth maxWidth="md">
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="სათაური"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="title"
                        value={editData.title}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="აღწერა"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="descriptionShort"
                        value={editData.descriptionShort}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="ღილაკის ტექსტი"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="description"
                        value={editData.description}
                        onChange={handleInputChange}
                    />

                    <TextField
                        margin="dense"
                        label="სათაური (ინგლსურად)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="titleEng"
                        value={editData.titleEng}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="აღწერა (ინგლსურად)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="descriptionShortEng"
                        value={editData.descriptionShortEng}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="ღილაკის ტექსტი (ინგლსურად)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="descriptionEng"
                        value={editData.descriptionEng}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="ბმული"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="locationPath"
                        value={editData.locationPath}
                        onChange={handleInputChange}
                    />

                    <input
                        accept="image/png, image/jpeg"
                        style={{display: 'none'}}
                        id="edit-file-upload"
                        type="file"
                        onChange={handleEditFileChange}
                    />
                    <label htmlFor="edit-file-upload">
                        <Button variant="contained" component="span">
                            სურათის ატვირთვა
                        </Button>
                    </label>
                    {editFileName && (
                        <Box>
                            <img src={editFileURL} alt="Uploaded" style={{width: 100, height: 100}}/>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsEditOpen(false)}>გაუქმება</Button>
                    <Button onClick={handleEditSubmit}>შენახვა</Button>
                </DialogActions>
            </Dialog>
            <CropperModal
                open={cropModalOpen}
                imageSrc={rawImage}
                onClose={() => setCropModalOpen(false)}
                onCropComplete={(croppedBase64) => {
                    setFile(croppedBase64);
                    setFileName('cropped.jpg');
                    setFileURL(croppedBase64);
                    setInputKey(Date.now());
                }}
            />

            <CropperModal
                open={editCropModalOpen}
                imageSrc={editRawImage}
                onClose={() => setEditCropModalOpen(false)}
                onCropComplete={(croppedBase64) => {
                    setEditFile(croppedBase64);
                    setEditFileName('edited-cropped.jpg');
                    setEditFileURL(croppedBase64);
                }}
            />


            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleConfirm}
            />
            <ConfirmationModal
                isOpen={isModalOpenDelete}
                onRequestClose={handleCloseModal}
                onConfirm={handleDelete}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default MainPageManager;
